export const IG_POSTS = [
  {
    id: 'ig1',
    type: 'Reel',
    img: 'https://picsum.photos/seed/ig_post_01/500/500',
    alt: 'Vedic astrology post',
    likes: '5.2K',
    comments: 342,
    caption: '✨ Your birth chart holds the answers. Watch this reel to understand your Lagna and how it shapes your entire destiny. #VedicAstrology #Kundli',
    time: '2 DAYS AGO',
  },
  {
    id: 'ig2',
    type: 'Post',
    img: 'https://picsum.photos/seed/ig_post_02/500/500',
    alt: 'Gemstone post',
    likes: '8.7K',
    comments: 521,
    caption: '💎 New Blue Sapphire collection — each stone personally selected & energised. Swipe to see. #Neelam #Gemstones #VedicRemedies',
    time: '4 DAYS AGO',
  },
  {
    id: 'ig3',
    type: 'Reel',
    img: 'https://picsum.photos/seed/ig_post_03/500/500',
    alt: 'Puja ritual',
    likes: '12K',
    comments: 893,
    caption: '🪔 Morning Surya puja — 10 minutes to start your day with divine energy. Save this reel to watch again. #Puja #VedicRitual #MorningRoutine',
    time: '1 WEEK AGO',
  },
  {
    id: 'ig4',
    type: 'Post',
    img: 'https://picsum.photos/seed/ig_post_04/500/500',
    alt: 'Kundli reading',
    likes: '6.4K',
    comments: 418,
    caption: '📜 Session snapshot — every chart tells a unique story. Book your reading through the link in bio. #Astrology #KundliReading',
    time: '10 DAYS AGO',
  },
  {
    id: 'ig5',
    type: 'Reel',
    img: 'https://picsum.photos/seed/ig_post_05/500/500',
    alt: 'Saturn transit',
    likes: '9.1K',
    comments: 674,
    caption: '🪐 Saturn transit 2026 — what it means for your sign. Full breakdown in this reel. Save & share! #SaturnTransit #VedicAstrology',
    time: '2 WEEKS AGO',
  },
  {
    id: 'ig6',
    type: 'Post',
    img: 'https://picsum.photos/seed/ig_post_06/500/500',
    alt: 'Daily mantra',
    likes: '7.3K',
    comments: 502,
    caption: "ॐ Today's mantra for protection and prosperity. Repeat 108 times every morning. Save this for your daily practice 🙏 #DailyMantra #Vedic",
    time: '3 WEEKS AGO',
  },
]
